<template>
  <router-link :to="path"  class="list-item d-block px-15 py-20">
    <div class="text_content-q-a mb-15">
      <span class="list-item__title c-text-body">{{ item.content }}</span>
    </div>
    <nav class="level fs-12">
      <!-- Left side -->
      <div class="level-left">
        <p class="level-item mr-30">
          <i class="far fa-comment c-text-primary" style="font-size: 16px; margin-right: 8px;"></i>
          <span class="c-text-body">{{ item.numOfAnswer }}</span>
        </p>
        <p class="level-item">
          <span class="c-text-grey4">{{ time }}</span>
        </p>
      </div>

      <!-- Right side -->
      <div class="level-right">
        <div class="level-item"><span class="c-text-grey4">{{ categoryName }}</span></div>
      </div>
    </nav>
  </router-link>
</template>

<script>
import { showDate } from '@/utils/commonUtil';

export default {
  name: 'QAListItem',
  props: {
    path: {
      type: [Object, String],
      default: () => ''
    },
    item: {
      type: Object,
      default: () => ({
        category: '1',
        content: '',
        bestAnswerId: '',
        numOfAnswer: '',
        createdAt: ''
      })
    }
  },
  data() {
    return {
      content: '',
      bestAnswerId: null,
      numOfAnswer: 0,
      status: 0
    };
  },
  computed: {
    categoryName: function() {
      let result = '';
      const categories = this.$t('categories_q_a');
      const category = categories.filter(item => item.value === parseInt(this.item.category, 10));

      if (category.length) result = category[0].name;

      return result;
    },
    time: function() {
      return showDate(new Date(this.item.createdAt));
    }
  }
};
</script>
